import {useEffect} from 'react';
import {useLocation,useNavigate} from 'react-router-dom';
import {loadRedirects,matchRedirect} from '@/lib/redirects';

// Global runtime redirect applier (covers redirect sources that map onto real routes).
// Legacy/unknown URLs are handled flash-free by CatchAll on the `*` route.
export default function Redirects(){
  const loc=useLocation();
  const navigate=useNavigate();
  useEffect(()=>{
    let alive=true;
    loadRedirects().then(()=>{
      if(!alive)return;
      const dest=matchRedirect(loc.pathname);
      if(!dest)return;
      if(/^https?:\/\//i.test(dest))window.location.replace(dest);
      else navigate(dest,{replace:true});
    });
    return()=>{alive=false;};
  },[loc.pathname,navigate]);
  return null;
}
